import { render, staticRenderFns } from "./ProductPage.vue?vue&type=template&id=132920d8&scoped=true"
import script from "./ProductPage.vue?vue&type=script&lang=js"
export * from "./ProductPage.vue?vue&type=script&lang=js"
import style0 from "./ProductPage.vue?vue&type=style&index=0&id=132920d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132920d8",
  null
  
)

export default component.exports